import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {Overlay, Popover} from 'react-bootstrap'
import {tutorialStepIsOnSelector, stopTutorial, tooltipGeneralProps, stepsData, handleStep_createSubjectModalStep, tutorialStepSelector, handleStep_clickCreateCategoryStep, handleStep_createCategoryModalStep, CLICK_CREATE_SUBJECT_STEP, SELECT_SUBJECT_STEP, CLICK_CREATE_CATEGORY_STEP} from '../../modules/tutorial'
import cn from 'classnames'


class TooltipStep extends Component {
    render() {
        const {step, text, tutorialStepIsOn, stopTutorial, tutorialStep : {target, container} = {}} = this.props
        const {formatMessage} = this.context

        const okCb = this.getOkCb()

        if (!tutorialStepIsOn) return null

        return (
            <Overlay
                container = {container}
                target = {target}
                show = {tutorialStepIsOn}
                placement = {stepsData[step].tooltipProps.placement}
            >
                <Popover
                    {...tooltipGeneralProps}
                    {...stepsData[step].tooltipProps}
                    className="popover-custom"
                >
                    <div className="tooltip-step">
                        <p>{formatMessage(text)}</p>
                        <div className="flex flex-between">
                            <button onClick={stopTutorial} className={cn("btn", stepsData[step].cancelBtnClassName)}>{formatMessage(stepsData[step].cancelBtnTxt)}</button>
                            {
                                typeof okCb === "function" && (
                                    <button onClick={okCb} className="btn btn-info">{formatMessage(stepsData[step].okBtnTxt)}</button>
                                )
                            }
                        </div>
                    </div>
                </Popover>
            </Overlay>
        )
    }

    getOkCb = () => {
        const {step, handleStep_createSubjectModalStep, handleStep_clickCreateCategoryStep, handleStep_createCategoryModalStep} = this.props
        switch (step) {
            case CLICK_CREATE_SUBJECT_STEP : {
                return handleStep_createSubjectModalStep
                break
            }
            case SELECT_SUBJECT_STEP : {
                return () => handleStep_clickCreateCategoryStep(true)
                break
            }
            case CLICK_CREATE_CATEGORY_STEP : {
                return handleStep_createCategoryModalStep
                break
            }
            default : {
                return
                break
            }
        }
    }

    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    (state, ownProps) => ({
        tutorialStepIsOn : tutorialStepIsOnSelector(state, ownProps.step),
        tutorialStep : tutorialStepSelector(state, ownProps.step),
    }),
    { stopTutorial, handleStep_createSubjectModalStep, handleStep_clickCreateCategoryStep, handleStep_createCategoryModalStep }
)(TooltipStep)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/tutorial/TooltipStep.js